module.exports = __webpack_public_path__ + "img/lp.fa0625fd.jpg";